import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

// First name for greetings: the saved full name if there is one, otherwise the part of the
// email before the @ ("alexis.k@x.com" -> "Alexis").
const fromEmail = (email = '') => {
  const raw = email.split('@')[0].split(/[._-]/)[0] || '';
  return raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : '';
};

export const useDisplayName = () => {
  const { user } = useAuth() || {};
  const [fullName, setFullName] = useState('');

  useEffect(() => {
    if (!user?.id) return;
    let cancelled = false;
    supabase.from('user_profiles').select('full_name').eq('id', user.id).maybeSingle()
      .then(({ data }) => { if (!cancelled && data?.full_name) setFullName(data.full_name); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user?.id]);

  const first = (fullName.trim().split(/\s+/)[0]) || fromEmail(user?.email);
  return { firstName: first, fullName: fullName || first, email: user?.email || '' };
};
